<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
        </a-card>

        <channelSelecter :isDisabled="!is_new" style="border-bottom:1px solid #eaeaea;" @onChannelCodeChange="handleCodeChange"></channelSelecter>

        <div class="bolck_box">
            <a-card  size="small" title="">
                <a-row>
                    <a-col :span="4">

                    </a-col>
                    <a-col :span="16">
                        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout">
                            <a-form-model-item ref="messagestypecode"  prop="messagestypecode" label="业务分类编码">
                                <a-input v-if="is_vue_task" v-model="record.messagestypecode" @blur=" () => {$refs.messagestypecode.onFieldBlur();}" />
                                <span v-else>{{record.messagestypecode}}</span>
                            </a-form-model-item>
                            <a-form-model-item ref="messagestypename" label="业务分类名称" prop="messagestypename">
                                <a-input v-if="is_vue_task" v-model="record.messagestypename" @blur=" () => {$refs.messagestypename.onFieldBlur();}" />
                                <span v-else>{{record.messagestypename}}</span>
                            </a-form-model-item>
                            
                            <a-form-model-item ref="icon" label="图标" prop="icon">
                                <a-input v-if="is_vue_task" v-model="record.icon" @blur=" () => {$refs.icon.onFieldBlur();}" />
                                <span v-else>{{record.icon}}</span>
                            </a-form-model-item>

                            <a-form-model-item ref="isscreenB" label="是否订阅" prop="isscreenB">
                                <a-switch v-model="isscreenB"/>
                            </a-form-model-item>
                        </a-form-model>
                    </a-col>
                </a-row>

            </a-card>
        </div>



        <a-button v-if="is_vue_task" type="primary" @click="handleOk" :loading="confirmLoading" style="display:block;margin:24px auto;">
            保存
        </a-button>
    </div>

</template>
<script>
import channelSelecter from '../../components/channelSelecter'
const m_title = {
    'add_servicetype':'新增业务分类',
    'detail_servicetype':'查看业务分类',
    'edit_servicetype':'编辑业务分类',
};

export default {
    components:{
        channelSelecter
    },
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                messagestypename:[
                    { required: true, message: '请输入业务分类名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                messagestypecode:[
                    { required: true, message: '请输入业务分类编码', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            isscreenB:true,

            record:{
                id:'',
                channelcode:'',
                channelname:'',
                messagestypecode:'',//--
                messagestypename:'',//--
                icon:'',
                isscreen:'01'
            }
        };
    },

    methods: {
    
        handleCodeChange(item){
            this.record.channelcode = item.value;
            this.record.channelname = item.text;
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.submitData();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        submitData(){
            this.confirmLoading = true;
            const { params } = this.$route;
            this.record.isscreen = this.isscreenB  ? '01' : '02'
            if(params.action == 'edit_servicetype'){
                this.$store
                    .dispatch({
                        type: "mcmsmanager/mcmsmessagetypeEdit",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
            else if(params.action == 'add_servicetype'){
                this.record.id = '';
                //新增
                this.$store
                    .dispatch({
                        type: "mcmsmanager/mcmsmessagetypeAdd",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.record.messagestypecode = 'MSGTYPECODE-000'

        },

        getDetail(id){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/mcmsmessagetypeQuery",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data.list[0];
                    that.record = {
                        ...result
                    }
                    that.isscreenB = that.record.isscreen == '01'
                }
            });
        },
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_servicetype";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_servicetype'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}


.bolck_box{
    padding: 20px;
}


</style>
